import { Box, Link, Typography, useTheme } from "@mui/material";
import React, { useContext } from "react";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";
import { useGetUserDetail } from "src/hooks/react-query/useAuth";

const HelperLink = ({ helperText, actionText, style = {}, textColor }) => {
  const theme = useTheme();
  const { supportCenterURL } = useContext(WhiteLabelConfigurationContext);
  const { data: userDetails } = useGetUserDetail();
  const isWhiteLabelContext =
    Boolean(userDetails?.isWhiteLabel) || Boolean(userDetails?.whiteLabelUserId);
  const showLearnMore = isWhiteLabelContext
    ? userDetails?.learnMoreLinkedinEnable === true
    : true;

  if (!showLearnMore) {
    return null;
  }

  const defaultUrl = "https://help.b2brocket.ai/";
  const url = supportCenterURL || defaultUrl;
  const normalizedUrl =
    url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;

  return (
    <Box sx={{ ...style }}>
      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: 500,
          color: textColor || theme.palette.text.primary,
          lineHeight: "18px",
          display: "inline",
        }}
      >
        {helperText}
        <Link
          href={normalizedUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: "13px",
            fontWeight: 600,
            lineHeight: "18px",
            color: theme.palette.primary.main,
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
              color: theme.palette.primary.dark,
            },
            display: "inline",
          }}
        >
          [{actionText}]
        </Link>
      </Typography>
    </Box>
  );
};

export default HelperLink;
